import "./textInput.css";
export { default } from "./TextInputBEM";

// If want styled component, import from here, it not
// import component file
